import React, { useEffect, useState } from "react";
import { factorFormData } from "../../forms/FactorForm";
import { CheckBoxInput, FormTypeSelectionInput, TextAreaInput } from "../Input";
import "../../assets/styles/productServices/addProduct.scss";
import bookMarkFactorWhite from "../../assets/svg/bookMarkFactorWhite.svg";

import { formatDate, formatPrice, setSelectItemLabels } from "../../helpers";
import { useDispatch, useSelector } from "react-redux";
import { resetForm, setEditItem, updateAccounting, updateFactor } from "../../store/actions/formAction";
import { RenderFactorInputs } from "../Input/render";
import { appReset } from "../../store/actions/appAction";
import { useLocation, useNavigate } from "react-router-dom";
import { PageHeader } from "../Form/components";
import { apiGetAccounting, apiSaveAccounting, apiUpdateAccounting } from "../../api/accountingApi";
import { apiGetAccountingTypeDetails } from "../../api/accountingTypeApi";
import ContainedTabs from "components/Tabs/Tabs3";

const secretViewValue = "****";

export const AccountingForm = (props) => {
  const { accountingId, factorType, header, activeTab, setActiveTab, displayHeader = false } = props;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const copy = queryParams.get("copy") === "1";
  const sendingRequest = useSelector((state) => state).appReducer.sendingRequest;
  const editItem = useSelector((state) => state).formReducer.editItem;
  const accountingData = useSelector((state) => state).formReducer.accounting ?? {};
  const currencies = useSelector((state) => state).currencyReducer.currencies;
  const token = useSelector((state) => state).businessReducer.business?.token;
  const factor = props.form ?? factorFormData.factor;
  let defaultValue = factor.tabs[0].key ?? "accounting";
  const [factorTab, setFactorTab] = useState(defaultValue);
  const [loading, setLoading] = useState(false);
  const [isCurrency, setCurrency] = useState(false);
  const columns = factor.tabs.find((tab) => tab.key === factorTab).form.body

  const bodyInputs =
    columns[0].inputs.filter(y => {
      if (isCurrency && y.isCurrency) {
        return true
      } else if (isCurrency && !y.isCurrency) {
        if (y.key == "creditor" || y.key == "debtor") {
          return false
        } else {
          return true
        }
      } else if (!isCurrency && !y.isCurrency) {
        return true
      }
    })
  const filterColumns = [{ ...columns[0], inputs: bodyInputs }]
  const descriptionInput = {
    formType: "accounting",
    name: "description",
    label: "شرح",
    rows: 5,
    required: true,
  };

  useEffect(() => {
    dispatch(appReset());
    dispatch(resetForm())
    dispatch(updateAccounting("items", []));
    // dispatch(resetFactor())
    // updateValue();

    if (accountingId) {
      dispatch(apiGetAccounting(accountingId, factorType, token));
    } else {
      dispatch(setEditItem(null));
    }
  }, []);

  useEffect(() => {
    if (editItem) {
      let index = 0;
      const currency = currencies.find((c) => c.id === editItem.currency_exchange);
      setLoading(true);
      if (editItem.CurrencyId !== null && editItem.CurrencyId !== 1) {
        setCurrency(true)
      }
      const items = editItem.Accounting_Items.map((i) => {
        i.accounting = setSelectItemLabels(i.Account_Type, "id", "title");
        if (currency) {
          i.currency = currency;
        }
        dispatch(
          apiGetAccountingTypeDetails(i.AccountTypeId, token, (details) => {
            i.accounting.detail = details?.find((d) => d.id === i.detail_id) ?? null;
            i.accounting.details = details;
          })
        );
        i.index = index;
        // i.accounting = i.Account_Type;
        i.creditor = i.isCreditor ? i.amount : 0;
        i.debtor = i.isCreditor ? 0 : i.amount;
        i.price = i.amount * (i.isCreditor ? 1 : -1);
        index++;

        return i;
      });
      dispatch(updateAccounting("items", items));
      dispatch(updateAccounting("description", editItem.description));
      // dispatch(updateAccounting("reference", editItem.reference));
      dispatch(updateAccounting("accountingCode", editItem.accountingCode.toString()));
      dispatch(updateAccounting("date", formatDate(editItem.date, true, true)));
      dispatch(updateAccounting("project", setSelectItemLabels(editItem.Project, "id", "title")));
      dispatch(updateAccounting("branch", setSelectItemLabels(editItem.Branch, "id", "title")));

      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  }, [editItem]);

  const onChange = (factorTab) => {
    setFactorTab(factorTab);
    dispatch(updateFactor("factorTab", factorTab));
  };

  return loading ? (
    <div />
  ) : (
    <>
      {displayHeader ? (
        <div className="wrap-add-product row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <PageHeader header={header} spaceLess={true} />
          </div>
        </div>
      ) : null}
      <div className="header-factor">
        <FormTypeSelectionInput
          form={factor}
          activeTab={factorTab}
          setActiveTab={onChange}
          checkEditItem={false}
        />
        <div className="flex-row d-flex">
          {factor.tabs.find((tab) => tab.key === factorTab).form.draftOption ? (
            <CheckBoxInput input={factor.tabs.find((tab) => tab.key === factorTab).form.draftInput} />
          ) : null}
          {factor.tabs.find((tab) => tab.key === factorTab).form.returnOption ? (
            <CheckBoxInput input={factor.tabs.find((tab) => tab.key === factorTab).form.returnInput} />
          ) : null}
        </div>
      </div>
      <div className="body-top-factor">
        <div className="row">
          <div className="col-6">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 style-padding-inputs">
                <TextAreaInput input={descriptionInput} />
              </div>
              <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 mr-5 mt-8 place-items-center place-content-center">
                <ContainedTabs
                  tabs={[
                    { label: "سند عادی", activeColor: "#1062D0" },
                    { label: "سند ارزی", activeColor: "#1062D0" },
                  ]}
                  // centered={true}
                  onChange={(val) => {
                    setCurrency(val === 1)
                    dispatch(updateAccounting("isCurrency", val == 1));

                  }}
                  activeTab={isCurrency ? 1 : 0}
                  size={2}
                  minWidth={46}
                  styles={{ tab: { margin: '0px 12px' } }}
                />
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 mr-5">
                {isCurrency &&
                  <RenderFactorInputs form={[
                    {
                      outerWrapperClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 offset-1 offset-xs-0",
                      type: "selectBox",
                      formType: "accounting",
                      style: {
                        paddingRight: "60px",
                        paddingLeft: "50px",
                      },
                      name: "CurrencyId",
                      key: "CurrencyId",
                      label: "نوع ارز",
                      primary: true,
                      showInput: true,
                      required: false,
                      options: "businessCurrencies",
                    },
                  ]} />
                }
              </div>
            </div>
          </div>
          <div className="col-6">
            <div className="row">
              <RenderFactorInputs form={factor.tabs.find((tab) => tab.key === factorTab).form.header} />
            </div>
          </div>
        </div>
      </div>
      <div className="body-top-factor">
        <div className="row">
          <RenderFactorInputs form={filterColumns}
          />
          <div className="mt-3">
            <div className="flex-row p-4 d-flex justify-content-between align-items-center border-top">
              <div className="flex-row d-flex">
                <div className="p-2" style={{ borderLeft: "1px solid #cacaca", minWidth: "120px" }}>
                  <div>
                    <span className="text-success">
                      {formatPrice(
                        accountingData.items?.reduce((sum, item) => {
                          return sum + +(item.creditor ?? 0);
                        }, 0) ?? 0
                      )}
                    </span>
                    <span className="mx-2 text-secondary">{accountingData.CurrencyId ? accountingData.CurrencyId.en_title : currencies[0].en_title}</span>
                  </div>
                  <div className="mt-2">
                    <span className=" small">بستانکار</span>
                  </div>
                </div>
                <div className="p-2" style={{ borderLeft: "1px solid #cacaca", minWidth: "120px" }}>
                  <div>
                    <span className="text-danger">
                      {formatPrice(
                        accountingData.items?.reduce((sum, item) => {
                          return sum + +(item.debtor ?? 0);
                        }, 0) ?? 0
                      )}
                    </span>
                    <span className="mx-2 text-secondary">{accountingData.CurrencyId ? accountingData.CurrencyId.en_title : currencies[0].en_title}</span>
                  </div>
                  <div className="mt-2">
                    <span className=" small">بدهکار</span>
                  </div>
                </div>
                <div className="p-2">
                  <div>
                    <span className="text-muted">
                      {formatPrice(
                        accountingData.items?.reduce((sum, item) => {
                          return sum + +((item.creditor ?? 0) - (item.debtor ?? 0));
                        }, 0) ?? 0
                      )}
                    </span>
                    <span className="mx-2 text-secondary">{accountingData.CurrencyId ? accountingData.CurrencyId.en_title : currencies[0].en_title}</span>
                  </div>
                  <div className="mt-2">
                    <span className=" small">تفاوت ارزی</span>
                  </div>
                </div>
                {isCurrency && <div className="p-2" style={{ borderRight: "1px solid #cacaca", minWidth: "120px" }}>
                  <div>
                    <span className="text-muted">
                      {formatPrice(
                        accountingData.items?.reduce((sum, item) => {
                          if (item.debtor) {
                            sum -= item.price
                            return sum
                          } else if (item.creditor) {
                            sum += item.price
                            console.log(sum, 'sumcreditor')
                            return sum
                          } else return sum
                        }, 0) ?? 0
                      )}
                    </span>
                    <span className="mx-2 text-secondary">{currencies[0].en_title}</span>
                  </div>
                  <div className="mt-2">
                    <span className=" small">تفاوت ارز پایه</span>
                  </div>
                </div>}
              </div>
              <div className="col-12 col-lg-3 btns-footer-box-left-right">
                <button
                  type="button"
                  disabled={sendingRequest}
                  className="save-and-continuation w-100"
                  onClick={() => {
                    if (accountingId && !copy) {
                      dispatch(
                        apiUpdateAccounting(accountingData, token, accountingId, () =>
                          navigate("/accounting")
                        )
                      );
                    } else {
                      if (copy) {
                        accountingData.accountingCode = null
                      }
                      dispatch(apiSaveAccounting(accountingData, token, () => navigate("/accounting")));
                    }
                  }
                  }
                >
                  <img src={bookMarkFactorWhite} alt="bookMarkFactor" />
                  {accountingId && !copy ? "به روزرسانی سند" : "ذخیره سند حسابداری"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
